import { Dispatch, SetStateAction } from 'react';
import Select from 'react-select';
import filter from '../../../../../assets/images/icons/filter.svg';
import { CustomStyle } from '../../../../../components/CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../../../components/CustomSelectStyleDarkTheme';
import useThemeContext from '../../../../../contexts/theme';
import { OptionType } from '../../types';
import { Container } from './styles';

interface FiltersI {
  routingStatus: OptionType;
  setRoutingStatus: Dispatch<SetStateAction<OptionType>>;
  routingStatusOptions: OptionType[];
  consultStatus: OptionType;
  setConsultStatus: Dispatch<SetStateAction<OptionType>>;
  consultStatusOptions: OptionType[];
}

export default function Filters({
  routingStatus,
  routingStatusOptions,
  setRoutingStatus,
  consultStatus,
  consultStatusOptions,
  setConsultStatus,
}: FiltersI) {
  const { selectedTheme } = useThemeContext();

  return (
    <Container>
      <header>
        <img src={filter} alt="filter" className="primaryColor" />
        <div>Pesquise através dos filtros abaixo</div>
      </header>

      <div style={{ justifyContent: 'space-evenly'}}>
        <div>
          <Select
            value={{ value: routingStatus?.value, label: routingStatus?.label === 'Todas' ? 'Filtrar por status Roteirização' : routingStatus?.label }}
            options={routingStatusOptions}
            onChange={(opr) => setRoutingStatus(opr as OptionType)}
            placeholder="Filtrar por status roteirização"
            styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container-as-filter"
          />
        </div>

        <div>
          <Select
            value={{ value: consultStatus?.value, label: consultStatus?.label === 'Todas' ? 'Filtrar por status Consulta' : consultStatus?.label }}
            options={consultStatusOptions}
            onChange={(opr) => setConsultStatus(opr as OptionType)}
            placeholder="Filtrar por status consulta"
            styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container-as-filter"
          />
        </div>
      </div>
    </Container>
  );
}
